export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/appsumo-original-bg-blue.85becbd5.svg","height":23,"width":47};